var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103 51.5C103 79.9427 79.9427 103 51.5 103C23.0573 103 0 79.9427 0 51.5C0 23.0573 23.0573 0 51.5 0C79.9427 0 103 23.0573 103 51.5ZM15.45 51.5C15.45 71.4099 31.5901 87.55 51.5 87.55C71.4099 87.55 87.55 71.4099 87.55 51.5C87.55 31.5901 71.4099 15.45 51.5 15.45C31.5901 15.45 15.45 31.5901 15.45 51.5Z",
    fill: "#1D1F2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.275 51.5C99.5414 51.5 103.059 48.0222 102.422 43.8037C101.223 35.8723 98.1817 28.2932 93.4981 21.6937C88.8144 15.0943 82.6638 9.72188 75.5726 5.97237C71.801 3.97812 67.357 6.15099 65.9488 10.1783C64.5406 14.2056 66.7276 18.5466 70.3633 20.779C74.4811 23.3075 78.0716 26.6522 80.8986 30.6356C83.7257 34.619 85.6979 39.1123 86.7255 43.8339C87.6328 48.0027 91.0086 51.5 95.275 51.5Z",
    fill: "url(#paint0_linear_3547_3173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3547_3173",
    x1: 66,
    y1: 5.5,
    x2: 104.5,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#091644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#63B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#57CBB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8FD675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8893BD",
    stopOpacity: 0.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerV2);
export default __webpack_public_path__ + "static/media/Spinner-V2.4f88d0f3fad20893c6a9ad9a632cbbc0.svg";
export { ForwardRef as ReactComponent };